module.exports = __webpack_public_path__ + "img/ic_camera.56a4f28c.svg";